module.exports = __webpack_public_path__ + "img/origination.b716cee1.png";